import script from "./NumberInputPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberInputPopup.vue?vue&type=script&setup=true&lang=js"

import "./NumberInputPopup.vue?vue&type=style&index=0&id=af4b75ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af4b75ac"]])

export default __exports__